export const SPEECH_LANGUAGES = [
  { code: "en-IN", label: "English" },
  { code: "hi-IN", label: "हिन्दी" },
  { code: "mr-IN", label: "मराठी" },
  { code: "ta-IN", label: "தமிழ்" },
  { code: "te-IN", label: "తెలుగు" },
  { code: "kn-IN", label: "ಕನ್ನಡ" },
  { code: "ml-IN", label: "മലയാളം" },
  { code: "bn-IN", label: "বাংলা" },
  { code: "gu-IN", label: "ગુજરાતી" },
  { code: "pa-IN", label: "ਪੰਜਾਬੀ" },
  { code: "ur-IN", label: "اردو" },
] as const;

export type SpeechLangCode = (typeof SPEECH_LANGUAGES)[number]["code"];

export const DEFAULT_SPEECH_LANG: SpeechLangCode = "en-IN";

export function isSupportedLang(code: string): code is SpeechLangCode {
  return SPEECH_LANGUAGES.some((l) => l.code === code);
}
